export const ADMIN_CREATE_BLOG_REQUEST = "ADMIN_CREATE_BLOG_REQUEST";
export const ADMIN_CREATE_BLOG_SUCCESS = "ADMIN_CREATE_BLOG_SUCCESS";
export const ADMIN_CREATE_BLOG_FAIL = "ADMIN_CREATE_BLOG_FAIL";

export const ADMIN_VIEW_BLOG_REQUEST = "ADMIN_VIEW_BLOG_REQUEST";
export const ADMIN_VIEW_BLOG_SUCCESS = "ADMIN_VIEW_BLOG_SUCCESS";
export const ADMIN_VIEW_BLOG_FAIL = "ADMIN_VIEW_BLOG_FAIL";

export const ADMIN_LIST_BLOG_REQUEST = "ADMIN_LIST_BLOG_REQUEST";
export const ADMIN_LIST_BLOG_SUCCESS = "ADMIN_LIST_BLOG_SUCCESS";
export const ADMIN_LIST_BLOG_FAIL = "ADMIN_LIST_BLOG_FAIL";

export const ADMIN_REMOVE_BLOG_REQUEST = "ADMIN_REMOVE_BLOG_REQUEST";
export const ADMIN_REMOVE_BLOG_SUCCESS = "ADMIN_REMOVE_BLOG_SUCCESS";
export const ADMIN_REMOVE_BLOG_FAIL = "ADMIN_REMOVE_BLOG_FAIL";

export const ADMIN_UPDATE_BLOG_REQUEST = "ADMIN_UPDATE_BLOG_REQUEST";
export const ADMIN_UPDATE_BLOG_SUCCESS = "ADMIN_UPDATE_BLOG_SUCCESS";
export const ADMIN_UPDATE_BLOG_FAIL = "ADMIN_UPDATE_BLOG_FAIL";
export const ADMIN_UPDATE_BLOG_PERMALINK_SUCCESS = "ADMIN_UPDATE_BLOG_PERMALINK_SUCCESS";
